export default [
  {
    title: 'Benvinguda',
    element: 'body',
    text: 'Benvingut a {{wlName}}, la teva plataforma mèdica d\'intercanvi d\'imatges. En aquesta visita us ajudarem a començar.'
  },
  {
    title: 'Mi Espai',
    element: '.idonia-header .toolbar__title',
    text: 'A "My Space" trobareu tota la vostra carpeta, documents i estudis emmagatzemats a Idonia.'
  },
  {
    title: '"+" Botó',
    element: '.action-fab button',
    text: 'Utilitzeu aquest menú per crear una carpeta, carregueu un fitxer o una carpeta des del vostre dispositiu.',
    clickNext: 'nav button',
    wait: 150,
    placement: {
      relativeTo: 'viewport',
      position: 'top'
    }
  },
  {
    title: 'Fitxers compartits',
    element: 'a[data-name="shared"]',
    text: 'A "Compartit amb mi" podràs veure els documents i carpetes compartits per altres usuaris.',
    clickBack: 'nav button',
    wait: 150
  }
]



// WEBPACK FOOTER //
// ./src/components/common/tour/tours/mobile/ca-ES/regular.js